// extracted by mini-css-extract-plugin
export default {"main":"MembersArea_main__38b3k","fadeIn":"MembersArea_fadeIn__J8vZ6","heading":"MembersArea_heading__TnkC5","anim-lineUp":"MembersArea_anim-lineUp__z8I01"};